import { FC } from 'react'
import 'swiper/css'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { useSwiperRef } from '@/shared/lib/hooks/useSwiperRef'
import { createMarkup } from '@/shared/lib/utils/common/createMarkup'

import { SwiperArrows } from '../swiper-arrows/swiper-arrows'

import cl from './style.module.scss'

export interface AdvantagesOurItem {
	title: string
	text: string
	Icon: FC
}

export const AdvantagesOur = (props: { items: AdvantagesOurItem[] }) => {
	const { items } = props
	const [nextEl, nextElRef] = useSwiperRef<HTMLButtonElement>()
	const [prevEl, prevElRef] = useSwiperRef<HTMLButtonElement>()

	return (
		<section className={cl.advantages}>
			<div className={cl.wrapper}>
				<h2 className={cl.title}>Преимущества</h2>
				<Swiper
					spaceBetween={20}
					slidesPerView={'auto'}
					className={cl.swiper}
					modules={[Navigation]}
					navigation={{
						nextEl,
						prevEl
					}}>
					{items.map(({ title, text, Icon }) => (
						<SwiperSlide key={title} className={cl.slide}>
							<Icon />
							<h4 dangerouslySetInnerHTML={createMarkup(title)} className={cl.name} />
							<p dangerouslySetInnerHTML={createMarkup(text)} className={cl.text} />
						</SwiperSlide>
					))}
				</Swiper>
				<SwiperArrows nextElRef={nextElRef} prevElRef={prevElRef} className={cl.arrows} />
			</div>
		</section>
	)
}
